import React from 'react';

const formatCurrency = value => {
    if (!value || isNaN(value)) return '0 €';
    return parseFloat(value).toLocaleString('es-ES', { 
        minimumFractionDigits: 0, 
        maximumFractionDigits: 2 
    }) + ' €';
};

const RoiBreakdown = ({ roi }) => (
    <div>
        <h4 className="font-semibold text-gray-700 mb-2">ROI por Períodos:</h4>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            {roi.map((roiItem, index) => (
                <div key={index} className="bg-gray-50 p-2 rounded text-center">
                    <div className="text-xs text-gray-600">{roiItem.year} año{roiItem.year > 1 ? 's' : ''}</div>
                    <div className="font-bold text-blue-600">{roiItem.roi}%</div>
                </div>
            ))}
        </div>
    </div>
);

const VentaDetails = ({ venta }) => (
    <div className="border-t pt-4">
        <h3 className="font-semibold text-blue-700 mb-3">📈 Datos de Venta</h3>
        <div className="grid grid-cols-2 gap-4 mb-4">
            <div className="bg-blue-50 p-3 rounded">
                <span className="text-sm text-gray-600">Precio Estimado:</span>
                <div className="font-bold text-lg text-blue-700">{formatCurrency(venta.precioEstimado)}</div>
            </div>
            <div className="bg-blue-50 p-3 rounded">
                <span className="text-sm text-gray-600">Rentabilidad Anual:</span>
                <div className="font-bold text-lg text-blue-700">{venta.rentabilidadAnual}%</div>
            </div>
        </div>
        
        {venta.roi && <RoiBreakdown roi={venta.roi} />}
    </div>
);

export default VentaDetails; 